import { render, staticRenderFns } from "./ConfirmEmailPage.vue?vue&type=template&id=fb61f5ec"
import script from "./ConfirmEmailPage.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailPage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmEmailPage.vue?vue&type=style&index=0&id=fb61f5ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports